import "@examspark/common-util/setupProcess";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";

import { delay } from "@examspark/common";
import { AppLoading } from "@examspark/common-app/preload";

const App = React.lazy(async () => {
  // artifically delay the loading of the app to prevent the loading screen
  // from flashing.
  const [, app] = await Promise.all([delay(1000), import("./App")]);
  return app;
});

// Only responsibility is to lazy-load the rest of the application.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Suspense fallback={<AppLoading />}>
    <App />
  </Suspense>,
  document.getElementById("root"),
);
